/* eslint-disable no-unused-vars */

/**
 * Waits until a dom element is in the DOM
 */
const waitUntilElementExists = (DOMSelector, MAX_TIME = 10000) => {
  let timeout = 0;

  const waitForContainerElement = (resolve, reject) => {
    const container = document.querySelector(DOMSelector);
    timeout += 30;

    if (timeout >= MAX_TIME) reject(`${DOMSelector} Element not found`);

    if (!container || container.length === 0) {
      setTimeout(waitForContainerElement.bind(this, resolve, reject), 30);
    } else {
      resolve(container);
    }
  };

  return new Promise((resolve, reject) => {
    waitForContainerElement(resolve, reject);
  });
};

/**
 * Wrap an element with another
 */
const wrapElement = (el, wrapper) => {
  if (el && el.parentNode) {
    el.parentNode.insertBefore(wrapper, el);
    wrapper.appendChild(el);
  }
};

/**
 * Wrap an array of items all at once
 */
const wrapAllElements = (ary, wrapper) => {
  if (ary && ary.length) {
    ary[0].parentNode.insertBefore(wrapper, ary[0]);
    for (var i in ary) {
      if (typeof ary[i] === 'object') {
        wrapper.appendChild(ary[i]);
      }
    }
  }
};

/**
 * Execute a callback function when the DOM is fully loaded.
 */
function domReady(callback) {
  document.addEventListener('DOMContentLoaded', callback);
  if (document.readyState === 'interactive' || document.readyState === 'complete') {
    callback();
  }
}

/**
 * Download the custom generated Image from a data URI
 */
function downloadVKImage() {
  const currentCanvas = document.querySelector(`[id^="VKCanvas-"]`);

  if (!currentCanvas) {
    // eslint-disable-next-line no-console
    console.log('Image canvas not found');
    return;
  }

  const dataURI = currentCanvas.generateURI();

  const variantContainer = document.querySelector(`vk-variant-radios`);

  // Get the variant name and normalize it
  const fieldsets = Array.from(variantContainer.querySelectorAll('fieldset'));
  const variantName = fieldsets.map((fieldset) => {
    const selectedValue = Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;

    // Update Legend text with the selected option color value
    // fieldset.querySelectorAll('legend span.vk-fieldset-value').forEach((span) => {
    //   span.textContent = selectedValue;
    // });

    return selectedValue
      .toString()
      .normalize('NFD') // split an accented letter in the base letter and the acent
      .replace(/[\u0300-\u036f]/g, '') // remove all previously split accents
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9 ]/g, '-') // remove all chars not letters, numbers and spaces (to be replaced)
      .replace(/\s+/g, '-');
  });

  // Create a link to download the image
  const link = document.createElement('a');
  link.download = `${variantName}.png`;
  link.href = dataURI;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  // eslint-disable-next-line no-delete-var
  delete link;

  return true;
}

/**
 * Chat fix
 */
window.ac = window.ac || {};
// eslint-disable-next-line no-undef
ac.chatLink = document.querySelector("a[href='#chat']");

// eslint-disable-next-line no-undef
if (ac.chatLink) {
  // eslint-disable-next-line no-undef
  ac.chatLink.addEventListener('click', function (e) {
    e.preventDefault();
    e.stopPropagation();

    const chat = document.getElementById('ShopifyChat');
    const iframeId = chat ? 'ShopifyChat' : 'dummy-chat-button-iframe';
    document.getElementById(`${iframeId}`).contentWindow.document.querySelector('button.chat-toggle').click();
  });
}

window.onload = function () {
  if (window.location.hash === '#chat') {
    setTimeout(function () {
      const chat = document.getElementById('ShopifyChat');
      const iframeId = chat ? 'ShopifyChat' : 'dummy-chat-button-iframe';
      document.getElementById(`${iframeId}`).contentWindow.document.querySelector('button.chat-toggle').click();
    }, 2000);
  }
};
